import type { RouteRecordRaw } from 'vue-router'
import BillingInvoicingDashboard from '@/views/billing/invoicing/dashboard.vue'
import UpdateInvoiceTemplate from '@/features/invoices/components/UpdateInvoiceTemplate.vue'
import AssetLayout from '@/features/assets/components/AssetLayout.vue'
import UpdateInvoice from '@/features/invoices/components/UpdateInvoice.vue'

export default [
  { path: '/billing/invoices',
    redirect: { name: 'invoices.list' }
  },
  { path: '/assets/:assetCode/invoicing/template',
    component: AssetLayout,
    children: [
      { path: '', name: 'assets.setupInvoice', component: UpdateInvoiceTemplate, props: true }
    ],
    props: true },
  { path: '/invoices',
    component: BillingInvoicingDashboard,
    name: 'invoices.list',
    meta: {
      pageTitle: 'Asset Invoices',
    }
  },
  { path: '/invoices/:invoiceId',
    name: 'invoices.update',
    component: UpdateInvoice,
    props: route => ({ invoiceId: parseInt(route.params.invoiceId as string, 10) }),
  }
] satisfies RouteRecordRaw[] as RouteRecordRaw[]
